import React from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

/* Aceternity noise-background, adapted for BookingFlows — animated conic
   gradient + fractal noise ring behind a CTA. */

const NOISE_URI =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.72' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

export const NoiseBackground = ({
  children,
  className,
  containerClassName,
  gradientColors = ["rgb(37, 99, 235)", "rgb(103, 232, 249)", "rgb(29, 78, 216)"],
  speed = 7,
}) => (
  <div className={cn("relative overflow-hidden rounded-full", containerClassName)}>
    <motion.div
      aria-hidden="true"
      className="absolute"
      style={{
        width: "300%",
        aspectRatio: "1 / 1",
        left: "50%",
        top: "50%",
        x: "-50%",
        y: "-50%",
        background: `conic-gradient(from 0deg, ${gradientColors.join(", ")}, ${gradientColors[0]})`,
      }}
      animate={{ rotate: 360 }}
      transition={{ duration: speed, repeat: Infinity, ease: "linear" }}
    />
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-40 mix-blend-overlay pointer-events-none"
      style={{ backgroundImage: NOISE_URI }}
    />
    <div className={cn("relative z-10", className)}>{children}</div>
  </div>
);

export default NoiseBackground;
